const gender = {
  male: '男',
  female: '女',
  other: 'Other',
  wontSpecify: "Won't Specify",
};

export default gender;
